import { WithSubpages } from '../../subpages';
import { customerAuthenticationSubpages } from '../../subpages/dictionary';
import { PAGE_TITLE } from '../../consts';

import { MAIN_PAGE_PATH } from './paths';

const CUSTOMER_AUTHENTICATION = () => (
  <WithSubpages
    mainPagePath={MAIN_PAGE_PATH}
    title={PAGE_TITLE.CUSTOMER_AUTHENTICATION}
    items={customerAuthenticationSubpages}
  />
);

export default CUSTOMER_AUTHENTICATION;
